<!-- AdminLayout.vue -->
<template>
  <div>
    <div class="container-scroller">
      <Headerr @toggleSidebar="toggleSidebar" />
      <div class="container-fluid page-body-wrapper">
        <Sidebar :isOpen="isSidebarOpen" />
        <div class="main-panel">
          <router-view></router-view>
          <chatBot/>
          <Footerr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Headerr from "../components/adminLayout/Header.vue";
import Sidebar from "../components/adminLayout/Sidebar.vue";
import Footerr from "../components/adminLayout/Footer.vue";
import chatBot from "../components/partials/chatBot.vue";

export default {
  name: "AdminLayout",
  components: { Headerr, Sidebar, Footerr, chatBot },
  data() {
    return {
      isSidebarOpen: false,
    };
  },
  watch: {
    // Watch the route for changes
    $route() {
      // Close the sidebar on route change
      this.isSidebarOpen = false;
    }
  },
  computed: {
    ...mapState({
        user: (state) => state.auth.user,
    }),
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
  },
  created() {
    if(this.user?.subscriptionStatus === "Expired"){
      this.$store
        .dispatch("currentUser")
        .then((res) => {
          console.log(res, 'res')
          if(res.data.data[0].subscriptionStatus === "Expired"){
            this.$router.push("/pricing")
          }
        })
        .catch((err) => {
          console.log(err,'err')
        });
    }
  },
};
</script>
